export const contactDetailsHeader = [
  "Name",
  "Tel. No.",
  "Fax No.",
  "Email",
  "Position",
];

export const contactDetailsBody = (contactPersons) => {
  const contactDetailsBody = contactPersons.map((contact) => {
    const {
      firstName,
      middleName,
      lastName,
      telephoneNumber,
      faxNumber,
      email,
      position,
    } = contact || {};

    return [
      `${firstName} ${middleName || ""} ${lastName}`,
      telephoneNumber,
      faxNumber,
      email,
      position,
    ];
  });

  return contactDetailsBody;
};
